export const isValidTelUrl = (str: string) => /^tel:[0-9-()+#*]+$/.test(str);
